import PrivatePageHOC from '../containers/PrivatPageHOC/PrivatePageHOC';
import UserProfileContainer from './UserProfileContainer';

export default PrivatePageHOC(UserProfileContainer);